import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgProgressService } from '@shared/services/ng-progress.service';
import { WalletService } from './wallet.service';
import {
  Transaction,
  TransactionStatus,
  Wallet,
  WalletTransaction,
  WalletType,
} from './wallet.model';
import { Subscription } from 'rxjs';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FluidModule } from 'primeng/fluid';
import { SkeletonModule } from 'primeng/skeleton';
import { PopoverModule } from 'primeng/popover';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { Router } from '@angular/router';
// import { CardsListComponent } from './cards-list/cards-list.component';
import { BankAccountsListComponent } from './bank-accounts-list/bank-accounts-list.component';
import { CustomCurrencyPipe } from '@shared/pipes/custom-currency.pipe';
import { ProfileService } from '../profile/profile.service';
import { StepperModule } from 'primeng/stepper';

@Component({
  selector: 'app-wallet',
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    AngularSvgIconModule,
    ReactiveFormsModule,
    FluidModule,
    SkeletonModule,
    PopoverModule,
    DialogModule,
    InputTextModule,
    InputNumberModule,
    InputMaskModule,
    DividerModule,
    SelectModule,
    StepperModule,
    // CardsListComponent,
    BankAccountsListComponent,
    TableModule,
    CustomCurrencyPipe,
  ],
  templateUrl: './wallet.component.html',
})
export class WalletComponent implements OnInit, AfterViewInit, OnDestroy {
  wallet: Wallet | null = null;
  walletTransactions: WalletTransaction[] = [];
  currency: string | undefined;
  isTouchDevice: boolean = false;
  readonly WalletType = WalletType;
  readonly TransactionStatus = TransactionStatus;
  readonly Transaction = Transaction;

  private walletSub = Subscription.EMPTY;
  private walletTransactionsSub = Subscription.EMPTY;

  readonly _walletService = inject(WalletService);
  private readonly _ngProgressService = inject(NgProgressService);
  private readonly _router = inject(Router);
  private readonly _profileService = inject(ProfileService);

  ngOnInit(): void {
    this.isTouchDevice = matchMedia('(pointer: coarse)').matches;
    this._ngProgressService.startLoader();

    this.currency = this._profileService.profile.currency;

    this.walletSub = this._walletService.wallet$.subscribe(
      (wallet) => (this.wallet = wallet)
    );

    this.walletTransactionsSub =
      this._walletService.walletTransactions$.subscribe(
        (walletTransactions) => (this.walletTransactions = walletTransactions)
      );

    this._walletService.getWallet();
    this._walletService.getWalletTransactions();
  }

  ngAfterViewInit(): void {
    this._ngProgressService.completeLoader();
  }

  // We will use this later
  // onDeposit(): void {
  //   this._router.navigate(['home/wallet/deposit']);
  // }

  onDeposit(): void {
    this._router.navigate(['home/wallet/bank-deposit']);
  }

  onWithdraw(): void {
    this._router.navigate(['home/wallet/withdraw']);
  }

  ngOnDestroy(): void {
    this.walletSub.unsubscribe();
    this.walletTransactionsSub.unsubscribe();
  }
}
